if (!customElements.get("variant-picker")) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
    }

    get selectedOptionValues() {
      const options = this.querySelectorAll('.m-product-option select, .m-product-option input');
      const selectedValues = new Map();

      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;

        if (field.tagName.toLowerCase() === "select") {
          const selectedOption = Array.from(field.options).find(
            (opt) => opt.selected && !opt.disabled
          );
          if (selectedOption) {
            selectedValues.set(fieldName, selectedOption.dataset.optionValueId);
          }
        } else if (
          field.tagName.toLowerCase() === "input" &&
          field.type === "radio"
        ) {
          const checkedInput = field.checked ? field : null;
          if (checkedInput) {
            selectedValues.set(fieldName, checkedInput.dataset.optionValueId);
          }
        }
      });

      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;

        if (!selectedValues.has(fieldName)) {
          if (field.tagName.toLowerCase() === "select") {
            const firstValidOption = Array.from(field.options).find(
              (opt) => !opt.disabled
            );
            if (firstValidOption) {
              selectedValues.set(
                fieldName,
                firstValidOption.dataset.optionValueId
              );
            }
          } else if (
            field.tagName.toLowerCase() === "input" &&
            field.type === "radio"
          ) {
            const firstInput = field;
            if (firstInput) {
              selectedValues.set(fieldName, firstInput.dataset.optionValueId);
            }
          }
        }
      });

      const result = [];
      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;
        if (selectedValues.has(fieldName)) {
          const optionValueId = selectedValues.get(fieldName);
          if (optionValueId && !result.includes(optionValueId)) {
            result.push(optionValueId);
          }
        }
      });
      return result;
    }

    get selectedOptions() {
      const optionContainers = this.querySelectorAll('.m-product-option');
      const selectedValues = [];

      optionContainers.forEach((container) => {
        const select = container.querySelector('select');
        if (select) {
          selectedValues.push(select.value);
        } else {
          const checkedRadio = container.querySelector('input[type="radio"]:checked');
          if (checkedRadio) {
            selectedValues.push(checkedRadio.value);
          } else {
            // Fallback: if no radio is checked, get the first one's value
            const firstRadio = container.querySelector('input[type="radio"]');
            if (firstRadio) {
              selectedValues.push(firstRadio.value);
            }
          }
        }
      });

      return selectedValues;
    }

    get variants() {
      const variantsScript = this.querySelector('script[data-variants]');
      if (!variantsScript) return [];
      try {
        return JSON.parse(variantsScript.textContent);
      } catch (e) {
        return [];
      }
    }

    get selectedVariant() {
      const selectedOptions = this.selectedOptions;
      const variants = this.variants;
      if (!variants.length || !selectedOptions.length) return null;

      const normalize = (str) => String(str || '').replace(/\s+/g, '').toLowerCase();

      return variants.find((variant) => {
        return selectedOptions.every((val, index) => {
          return normalize(variant.options[index]) === normalize(val);
        });
      });
    }

    selectOptions(optionValues) {
      if (!optionValues || !optionValues.length) return;
      const optionContainers = this.querySelectorAll('.m-product-option');
      optionValues.forEach((optionValue, index) => {
        const container = optionContainers[index];
        if (!container) return;

        const select = container.querySelector('select');
        if (select) {
          select.value = optionValue;
        } else {
          const radios = container.querySelectorAll('input[type="radio"]');
          radios.forEach((radio) => {
            if (radio.value === optionValue) {
              radio.checked = true;
            } else {
              radio.checked = false;
            }
          });
        }
      });
    }

    connectedCallback() {
      this.addEventListener('change', (event) => {
        const target = this.getInputForEventTarget(event.target);
        MinimogEvents.emit(MinimogTheme.pubSubEvents.optionValueSelectionChange, { data: { selectedOptionValues: this.selectedOptionValues, event, target } });
      });
    }

    getInputForEventTarget(target) {
      return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
    }
  }
  customElements.define("variant-picker", VariantPicker);
}